import { render, staticRenderFns } from "./PaymentMethodSelector.vue?vue&type=template&id=8c49b600&"
import script from "./PaymentMethodSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodSelector.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports